import { ICourse, ISection } from '@sdk/contracts';
import { Button, Form, Input, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TextAreaWrapper, Wrapper } from './AddSection.styles';

import { Icon } from '@/components/Icon';
import { RULES } from '@/constants';
import { useMutateSection } from '@/store';

type Props = {
  course: ICourse;
};

const MAX_LENGTH = 750;
const TEXT_AREA_ROWS = 3;

export const AddSection: React.FC<Props> = ({ course }) => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const { createSection } = useMutateSection();
  const { t } = useTranslation(['CourseTranslations', 'DefaultTranslations']);

  const name = Form.useWatch('name', form);

  const handleCancel = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const handleFinish = (values: ISection) => {
    createSection({ course, section: values }, { onSuccess: handleCancel });
  };

  const isNameValid = name && name.trim().length > 0;

  return (
    <Wrapper>
      <Button onClick={() => setIsOpen(true)} type="primary" icon={<Icon i="Add" />}>
        {t('CourseTranslations:CREATE_SECTION')}
      </Button>
      <Modal
        open={isOpen}
        onOk={form.submit}
        onCancel={handleCancel}
        title={t('CourseTranslations:CREATE_SECTION')}
        cancelText={t('DefaultTranslations:CANCEL')}
        okText={t('CourseTranslations:CREATE')}
        okButtonProps={{ disabled: !isNameValid }}
        centered>
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Form.Item name="name" rules={[RULES.REQUIRED]} label={t('CourseTranslations:NAME')}>
            <Input placeholder={t('CourseTranslations:SECTION_NAME_PLACEHOLDER')} />
          </Form.Item>

          <Form.Item name="description" label={t('CourseTranslations:DESCRIPTION')}>
            <TextAreaWrapper
              maxLength={MAX_LENGTH}
              showCount
              rows={TEXT_AREA_ROWS}
              placeholder={t('CourseTranslations:SECTION_DESCRIPTION_PLACEHOLDER')}
            />
          </Form.Item>
        </Form>
      </Modal>
    </Wrapper>
  );
};
